import * as actionTypes from "../../constants/actionTypes";
import * as handlers from "../../constants/handlers";
import * as resultCodes from "../../constants/resultCodes";
import * as messageHelper from "../../helpers/messageHelper";

export const processWebsocketResponse = (tabId, method, response) => {
    switch (method) {
        case handlers.GET_SPECTRO_XRITE_MODELS:
            if (response.result !== resultCodes.RCC_RESULT_OK) {
                return [messageHelper.getRccFlashMessage(response)];
            }

            return [
                {
                    type: actionTypes.SAVE_SPECTRO_XRITE_MODELS,
                    payload: {
                        xRiteModels: response.data
                    }
                }
            ];
        case handlers.GET_SPECTRO_COM_PORTS:
            if (response.result !== resultCodes.RCC_RESULT_OK) {
                return [messageHelper.getRccFlashMessage(response)];
            }

            return [
                {
                    type: actionTypes.SAVE_SPECTRO_COM_PORTS,
                    payload: {
                        comPorts: response.data
                    }
                }
            ];
        default:
            return [
                {
                    type: actionTypes.UNKNOWN_RCC_ACTION
                }
            ];
    }
};
